import Container from "../utils/Container"
import hero from '../../assets/cassation.jpg'

const Hero = () => {
  return (
    <>
      <section>
        <Container className="flex flex-col lg:flex-row justify-between gap-10 items-center">
          <div className="flex-2 text-center lg:text-start">
            <h1 className="text-4xl xl:text-5xl 2xl:text-6xl 2xl:leading-[1.2] xl:leading-[1.2] font-extrabold leading-[1.2] mb-4 xl:mb-8">
              Cabinet GIBERT
            </h1>
            <p className="leading-[2] mb-4 text-xs sm:text-sm sm:leading-[2]">
              Urgence Pénale : 06 14 02 25 58
            </p>
          </div>
          <img src={hero} alt="Hero" className="flex-1" />
        </Container>
      </section>
    </>
  )
}

export default Hero
